<button
  type="button"
  class="relative flex w-[32px] h-[32px] items-center justify-center rounded-lg focus-visible:outline-primary"
  [class.text-primary-text]="discussions.opened()"
  [class.dark:text-primary]="discussions.opened()"
  [attr.aria-label]="'DISCUSSIONS.TITLE' | translate"
  [title]="'DISCUSSIONS.TITLE' | translate"
  [attr.aria-expanded]="discussions.opened()"
  aria-controls="discussions-panel"
  (click)="discussions.toggle()"
>
  <span
    aria-hidden="true"
    class="block w-[32px] h-[32px] bg-current mask-[url(/assets/images/icons/chat.svg)] mask-contain mask-no-repeat"
  ></span>
  @if (discussions.unreadThreadCount()) {
  <span
    class="notification-count-badge notification-count-badge--floating color"
    >{{ discussions.unreadThreadCount() }}</span
  >
  }
</button>
